export default __webpack_public_path__ + "static/media/hr.37718104.svg";